const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvailableTask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "Two_Tone",
    "data-name": "Two Tone"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24 120h464a0 0 0 0 1 0 0v352a16 16 0 0 1 -16 16h-432a16 16 0 0 1 -16-16v-352a0 0 0 0 1 0 0z",
    fill: "#ffffff",
    "data-original": "#90caf9",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40 56h432a16 16 0 0 1 16 16v56a0 0 0 0 1 0 0h-464a0 0 0 0 1 0 0v-56a16 16 0 0 1 16-16z",
    fill: "#ffffff",
    "data-original": "#2096f3",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#00024a",
    height: 64,
    rx: 16,
    width: 32,
    x: 72,
    y: 24,
    "data-original": "#1665c0",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#00024a",
    height: 64,
    rx: 16,
    width: 32,
    x: 296,
    y: 24,
    "data-original": "#1665c0",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#00024a",
    height: 64,
    rx: 16,
    width: 32,
    x: 184,
    y: 24,
    "data-original": "#1665c0",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#00024a",
    height: 64,
    rx: 16,
    width: 32,
    x: 408,
    y: 24,
    "data-original": "#1665c0",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144 168h224v280h-224z",
    fill: "#ffffff",
    "data-original": "#ffecb3",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0d47a0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m248 400h96v16h-96z",
    fill: "#00024a",
    "data-original": "#0d47a0",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248 368h48v16h-48z",
    fill: "#00024a",
    "data-original": "#0d47a0",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248 320h96v16h-96z",
    fill: "#00024a",
    "data-original": "#0d47a0",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248 288h48v16h-48z",
    fill: "#00024a",
    "data-original": "#0d47a0",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248 240h96v16h-96z",
    fill: "#00024a",
    "data-original": "#0d47a0",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248 208h48v16h-48z",
    fill: "#00024a",
    "data-original": "#0d47a0",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m191.259 416a8 8 0 0 1 -5.656-2.343l-16-16 11.313-11.314 9.68 9.68 26.416-33.023 12.494 10-32 40a8 8 0 0 1 -5.8 2.99c-.152.01-.3.01-.447.01z",
    fill: "#00024a",
    "data-original": "#0d47a0",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m191.259 336a8 8 0 0 1 -5.656-2.343l-16-16 11.313-11.314 9.68 9.68 26.416-33.023 12.494 10-32 40a8 8 0 0 1 -5.8 2.99c-.152.01-.3.01-.447.01z",
    fill: "#00024a",
    "data-original": "#0d47a0",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m191.259 256a8 8 0 0 1 -5.656-2.343l-16-16 11.313-11.314 9.68 9.68 26.416-33.023 12.494 10-32 40a8 8 0 0 1 -5.8 2.99c-.152.01-.3.01-.447.01z",
    fill: "#00024a",
    "data-original": "#0d47a0",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144 456h224a8 8 0 0 0 8-8v-280a8 8 0 0 0 -8-8h-224a8 8 0 0 0 -8 8v280a8 8 0 0 0 8 8zm8-280h208v264h-208z",
    fill: "#00024a",
    "data-original": "#0d47a0",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m472 48h-24v-8a24 24 0 0 0 -48 0v8h-64v-8a24 24 0 0 0 -48 0v8h-64v-8a24 24 0 0 0 -48 0v8h-64v-8a24 24 0 0 0 -48 0v8h-24a24.028 24.028 0 0 0 -24 24v400a24.028 24.028 0 0 0 24 24h432a24.028 24.028 0 0 0 24-24v-400a24.028 24.028 0 0 0 -24-24zm-56-8a8 8 0 0 1 16 0v32a8 8 0 0 1 -16 0zm-112 0a8 8 0 0 1 16 0v32a8 8 0 0 1 -16 0zm-112 0a8 8 0 0 1 16 0v32a8 8 0 0 1 -16 0zm-112 0a8 8 0 0 1 16 0v32a8 8 0 0 1 -16 0zm400 432a8.009 8.009 0 0 1 -8 8h-432a8.009 8.009 0 0 1 -8-8v-336h448zm0-352h-448v-48a8.009 8.009 0 0 1 8-8h24v8a24 24 0 0 0 48 0v-8h64v8a24 24 0 0 0 48 0v-8h64v8a24 24 0 0 0 48 0v-8h64v8a24 24 0 0 0 48 0v-8h24a8.009 8.009 0 0 1 8 8z",
    fill: "#00024a",
    "data-original": "#0d47a0",
    style: {},
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailableTask);
export default __webpack_public_path__ + "static/media/available-task.d810506db1821d254c7e1fd98365ee72.svg";
export { ForwardRef as ReactComponent };